import i18n from '../../helpers/lang/i18n';

export const inputFormReale = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'insurancePolicyNumber',
      title: t('emision_de_cerificados.numero_poliza'),
      placeholder: t('emision_de_cerificados.numero_poliza'),
      value: null,
      cols: 4,
      label: 'number',
      type: 'select',
      showMarkRequired: true,
      formatValue: (val: any) => val?.number,
      options: [
        // { id: 1, number: '622500000142' },
        // { id: 1, number: '622500000014' },
        // { id: 2, number: '622400000312' },
        { id: 2, number: '622400000312 - Valencia' },
      ],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'onBehalfOf',
      title: t('emision_de_cerificados.por_cuenta_de'),
      placeholder: t('emision_de_cerificados.por_cuenta_de'),
      type: 'text',
      value: null,
      state: null,
      cols: 4,
      autocomplete: 'off',
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'insuranceBeneficiary',
      title: t('emision_de_cerificados.beneficiario_seguro'),
      placeholder: t('emision_de_cerificados.beneficiario_seguro'),
      type: 'text',
      state: null,
      cols: 4,
      autocomplete: 'off',
      showMarkRequired: true,
      value: "Quien ostente el interés sobre la mercancía en el momento del siniestro",
      disabled: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'insuranceBeneficiaryEmail',
      title: t('emision_de_cerificados.beneficiario_seguro_email'),
      placeholder: t('emision_de_cerificados.beneficiario_seguro_email'),
      type: 'email',
      value: null,
      state: null,
      cols: 4,
      showMarkRequired: true,
      autocomplete: 'off',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'currencyTypeId',
      title: t('emision_de_cerificados.moneda_prima'),
      placeholder: t('emision_de_cerificados.moneda_prima'),
      value: null,
      cols: 4,
      label: 'nombre',
      type: 'select',
      showMarkRequired: true,
      formatValue: (val: any) => val?.id,
      options: [],
      disabled: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'ref',
      title: t('emision_de_cerificados.referencia'),
      placeholder: t('emision_de_cerificados.referencia'),
      type: 'text',
      value: null,
      state: null,
      autocomplete: 'off',
      cols: 4,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'dateOfIssue',
      title: t('emision_de_cerificados.fecha_de_salida'),
      type: 'datetime',
      placeholder: t('emision_de_cerificados.fecha_de_salida'),
      value: null,
      enableTimePicker: false,
      format: 'dd/MM/yyyy',
      modelType: 'yyyy-MM-dd',
      autoApply: true,
      cols: 4,
      listenChange: true,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'insuredValue',
      title: t('emision_de_cerificados.valor_asegurado'),
      placeholder: t('emision_de_cerificados.valor_asegurado'),
      type: 'number',
      value: null,
      state: null,
      cols: 4,
      step: '0.01',
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'currencyOfInsuredValueId',
      title: t('emision_de_cerificados.moneda_valor_asegurado'),
      placeholder: t('emision_de_cerificados.moneda_valor_asegurado'),
      value: null,
      cols: 4,
      label: 'nombre',
      type: 'select',
      formatValue: (val: any) => val?.id,
      options: [],
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'carrier',
      title: t('emision_de_cerificados.transportista'),
      placeholder: t('emision_de_cerificados.transportista'),
      type: 'text',
      autocomplete: 'off',
      value: null,
      state: null,
      cols: 4,
    },
    {
      key: 'typePolicyTransportId',
      title: t('emision_de_cerificados.typeTransport'),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      showMarkRequired: true,
      placeholder: t('emision_de_cerificados.typeTransport'),
      value: null,
      cols: 4,
      label: 'nombre',
      type: 'select',
      listenSelect: true,
      formatValue: (val: any) => val?.id,
      options: [
        { id: 1, nombre: 'Terrestre' },
        { id: 2, nombre: 'Maritimo' },
        { id: 4, nombre: 'Aereo' },
        { id: 5, nombre: 'Multimodal' },
      ]
    },
    {
      key: 'vessel',
      title: t('emision_de_cerificados.buque'),
      placeholder: t('emision_de_cerificados.buque'),
      type: 'text',
      value: null,
      state: null,
      cols: 4,
    },
    {
      key: 'assetId',
      title: t('emision_de_cerificados.asset'),
      listenSelect: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      showMarkRequired: true,
      placeholder: t('emision_de_cerificados.asset'),
      value: null,
      cols: 4,
      label: 'nombre',
      type: 'select',
      formatValue: (val: any) => val?.id,
      options: [],
    },
    {
      key: 'marksAndNumbers',
      title: t('emision_de_cerificados.marcas_numero'),
      placeholder: t('emision_de_cerificados.marcas_numero'),
      type: 'text',
      autocomplete: 'off',
      value: null,
      state: null,
      cols: 4,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'descriptionOfTheGoods',
      title: t('emision_de_cerificados.description'),
      placeholder: t('emision_de_cerificados.description'),
      type: 'textarea',
      value: null,
      state: null,
      cols: 12,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
          max: 1500,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'cityOfOrigin',
      title: t('emision_de_cerificados.ciudad_origen'),
      placeholder: t('emision_de_cerificados.ciudad_origen'),
      type: 'text',
      value: null,
      state: null,
      autocomplete: 'off',
      cols: 6,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'countryOfOriginId',
      title: t('emision_de_cerificados.pais_de_origen'),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      showMarkRequired: true,
      placeholder: t('emision_de_cerificados.pais_de_origen'),
      value: null,
      cols: 6,
      label: 'nombre',
      type: 'select',
      formatValue: (val: any) => val?.id,
      options: [],
    },
    {
      key: 'cityOfDestination',
      title: t('emision_de_cerificados.ciudad_destino'),
      placeholder: t('emision_de_cerificados.ciudad_destino'),
      type: 'text',
      value: null,
      state: null,
      cols: 6,
      showMarkRequired: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'countryOfDestinationId',
      title: t('emision_de_cerificados.pais_de_destino'),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('emision_de_cerificados.pais_de_destino'),
      value: null,
      cols: 6,
      label: 'nombre',
      type: 'select',
      showMarkRequired: true,
      formatValue: (val: any) => val?.id,
      options: [],
    },
    {
      key: 'businessUnitId',
      title: t('emision_de_cerificados.filial'),
      listenSelect: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('emision_de_cerificados.filial'),
      value: null,
      cols: 6,
      label: 'nombre',
      type: 'select',
      showMarkRequired: true,
      formatValue: (val: any) => val?.id,
      options: [],
    },
    {
      // key: 'agenciaAltiusId',
      key: 'agencyId',
      title: t('emision_de_cerificados.agencias_altius'),
      listenSelect: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('emision_de_cerificados.agencias_altius'),
      value: null,
      cols: 6,
      label: 'name',
      type: 'select',
      showMarkRequired: true,
      formatValue: (val: any) => val?.id,
      options: [],
      hidden: true
    },
    {
      key: 'invoiceNumber',
      title: t('emision_de_cerificados.numero_factura'),
      placeholder: t('emision_de_cerificados.numero_factura'),
      type: 'text',
      value: null,
      state: null,
      autocomplete: 'off',
      cols: 6,
    },
    {
      key: 'additionalComments',
      title: t('emision_de_cerificados.comentarios_adicionales'),
      placeholder: t('emision_de_cerificados.comentarios_adicionales_placeholder'),
      type: 'textarea',
      validations: {
        rules: {
          max: 1500,
        },
      },
      value: null,
      state: null,
      cols: 12,
    },
  ];
};
